import { render, staticRenderFns } from "./DistributorLabel.vue?vue&type=template&id=aa68b6c0"
import script from "./DistributorLabel.vue?vue&type=script&lang=js"
export * from "./DistributorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports